
import { Hero } from "./Hero_2"

function HeroSection(props) {
  return <Hero {...props} />;
}

export default HeroSection;